import script from "./PageDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./PageDefault.vue?vue&type=script&setup=true&lang=js"

import "./PageDefault.vue?vue&type=style&index=0&id=37c21dbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c21dbb"]])

export default __exports__